import {
    tns
} from 'tiny-slider/src/tiny-slider';
var sliders = {}
export const start = async function(id) {
    await setTimeout(async () => {
        sliders[id] = createConfigFile();
        var slider = sliders[id];
        //
        updateInfos({
            displayIndex: 1
        });
        slider.events.on('transitionEnd', updateInfos);


        const dotsContainer = document.getElementById("dots_carouselContainerReference")
        const dots = Array.from(dotsContainer.getElementsByClassName("dot"))

        dots.forEach((dot, i) => {
            console.log('dot', dot, i)
            dot.addEventListener('click', e => changeSlide(slider, i));
        })


        const arrowContainer = document.getElementById('arrowContainer_carouselContainerReference');
        var right = arrowContainer.getElementsByClassName("right")
        right = right[0]
        var left = arrowContainer.getElementsByClassName("left")
        left = left[0]

        right.addEventListener('click', e => slider.goTo("next"));
        left.addEventListener('click', e => slider.goTo("prev"));


    }, 50)

    function updateInfos(e) {
        const container = document.getElementById('dots_carouselContainerReference');

        const dots = Array.from(container.getElementsByClassName("dot"))

        dots.forEach((dot, i) => {
            if ((i + 1) == e.displayIndex) {
                dot.classList.add("active")
            } else {
                dot.classList.remove("active")
            }
        })


        const arrowContainer = document.getElementById('arrowContainer_carouselContainerReference');
        var right = arrowContainer.getElementsByClassName("right")
        right = right[0]
        var left = arrowContainer.getElementsByClassName("left")
        left = left[0]

        if (e.displayIndex == 1) {
            left.classList.add("disabled")
        } else {
            left.classList.remove("disabled")

        }

        if (e.displayIndex == dots.length) {
            right.classList.add("disabled")
        } else {
            right.classList.remove("disabled")
        }

    }



    function changeSlide(slider, index) {
        slider.goTo(index);
    }

}


function createConfigFile() {
    return tns({
        container: '.base-reference',
        slideBy: 'page',
        autoplay: false,
        center: false,
        swipeAngle: false,
        loop: false,
        controls: false,
        items: 1,
        gutter: 0,
        nav: false,
        edgePadding: 0,
    });
}

export const stop = async function(id) {
    var slider = sliders[id]
    if (slider && slider.destroy) {
        await slider.destroy();
    }
    return true;
}
